import { z } from 'zod'
import { useApiMutation } from '../../utils/useApi'

// ============================================
// POST /set_site_live_status
// ============================================

const SetSiteLiveStatusRequestSchema = z
    .object({
        site: z.string().min(1, 'site must not be blank'),
        live: z.boolean()
    })
    .strict()

const SetSiteLiveStatusResponseSchema = z.object({
    site: z.string(),
    live: z.boolean()
})

export type SetSiteLiveStatusRequest = z.infer<typeof SetSiteLiveStatusRequestSchema>
export type SetSiteLiveStatusResponse = z.infer<typeof SetSiteLiveStatusResponseSchema>

export { SetSiteLiveStatusRequestSchema, SetSiteLiveStatusResponseSchema }

export const useSetSiteLiveStatusMutation = () =>
    useApiMutation<SetSiteLiveStatusRequest, typeof SetSiteLiveStatusResponseSchema>(
        '/access-control/set_site_live_status',
        SetSiteLiveStatusResponseSchema
    )
